import legendColor from './src/color'
import legendSize from './src/size'
import legendSymbol from './src/symbol'
import legendHelpers from './src/helpers'

export { legendColor, legendSize, legendSymbol, legendHelpers }

export default {
  legendColor,
  legendSize,
  legendSymbol,
  legendHelpers
};
